export enum ProcessingState {
  NOT_PROCESSED = "NOT_PROCESSED",
  PROCESSING_SUGGESTED_FOLDER = "PROCESSING_SUGGESTED_FOLDER",
  PROCESSED_SUGGESTED_FOLDER = "PROCESSED_SUGGESTED_FOLDER",
  PROCESSING_AI_SUMMARY = "PROCESSING_AI_SUMMARY",
  PROCESSED_AND_NOT_PLACED = "PROCESSED_AND_NOT_PLACED",
  PROCESSED_PLACED_NOT_SEEN = "PROCESSED_PLACED_NOT_SEEN",
  PROCESSED_SEEN = "PROCESSED_SEEN",
  CANNOT_BE_ANALYZED = "CANNOT_BE_ANALYZED",
}
